import { useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

/** Discounts the composer can hand out and the member's allowance today (LC12). */
export function useChatDiscounts(storeId: string, enabled: boolean) {
  return useQuery({
    queryKey: conversationKeys.discounts(storeId),
    queryFn: () => conversationsApi.discounts(storeId),
    enabled,
  });
}
